import RelaxationExerciseFlow from "@/components/Exercises/Relaxation/RelaxationExerciseFlow";
import { Button } from "@/components/ui/button";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { useChildSessionStore } from "@/lib/stores/childSessionStore";
import { FormattedMessage } from "react-intl";
import RelaxIntro from "@/assets/audios/Relaxation-Excercise-intro-sentence1.m4a";
import { ExerciseLayout } from "@/components/ui/exercise-layout";

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/relaxation/"
)({
  component: RouteComponent,
  head: () => ({
    meta: [
      {
        title: "An Exercise Through Muscle Relaxation - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "stress.exercises.relaxationExercise",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);
  const { selectedEmotionId, reset } = useChildSessionStore();
  const navigate = useNavigate();

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };

  const handleComplete = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
    if (selectedEmotionId) {
      navigate({ to: "/children/session" });
    }
  };

  const handleExit = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
    if (selectedEmotionId) {
      reset();
      navigate({ to: "/children/exercises" });
    }
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="treeOfLife.intro.start.button" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="relaxationExercise.intro" />
      </p>
      <MediaPlayer src={RelaxIntro} isPaused={isPausedAudio} />
      <RelaxationExerciseFlow
        onComplete={handleComplete}
        onExit={handleExit}
        isShow={showOverlay}
      />
    </ExerciseLayout>
  );
}
